module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('d-select', {
    attrs: {
      "items": _vm.usersForList,
      "itemsSelected": _vm.selectedUsers,
      "eventId": _vm.eventId,
      "allDataLoaded": _vm.allDataLoaded,
      "show": _vm.show,
      "addClass": _vm.addClass
    },
    on: {
      "remove": _vm.removeUser,
      "add": _vm.addUser,
      "addIsOnLesson": _vm.addedIsOnLesson,
      "update": _vm.setSelectedUsers,
      "show": _vm.getUsers
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.subFromIsOnLesson !== null) ? _c('div', {
    staticClass: "subModal__bg"
  }, [_c('div', {
    staticClass: "subModal"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['would_you_like_to_set']) + " " + _vm._s(_vm.subFromIsOnLesson.name) + " " + _vm._s(_vm.i18n['as_a_substitute_instead_of_teacher']) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "subModal__buttons"
  }, [_c('button', {
    on: {
      "click": _vm.setSubFromIsOnLesson
    }
  }, [_vm._v(_vm._s(_vm.i18n['yes']))]), _vm._v(" "), _c('button', {
    staticClass: "bttn-simple bttn",
    on: {
      "click": function($event) {
        _vm.subFromIsOnLesson = null
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n['no']))])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4eea129d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DSelect/DSelectSubs.vue
// module id = 1912
// module chunks = 1